module.exports = __webpack_public_path__ + "static/media/mac_pc.da18a8a2.svg";